/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CustomerDeleteMutation from './__mutation__/index.customer.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationCustomerDelete, MutationCustomerDeleteResponse] = useMutation(CustomerDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationCustomerDeleteResponse.loading} onConfirm={() =>
      MutationCustomerDelete({
        'variables': {
          'customerId': passOn?.customerId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.CustomerDelete?.message)

        // Refetch data.
        refetch?.()

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationCustomerDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
